import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  gap: 32px;
`;

export const LeftColumn = styled.div`
  flex: 1;
`;

export const RightColumn = styled.div`
  flex: 2;
`;
